// extracted by mini-css-extract-plugin
export default {"homeBody":"pages_homeBody__EYxeC","promotionContainer":"pages_promotionContainer__1KxId"};